export const translations = {
    hu: {
        nav: {
            home: 'Kezdőlap',
            events: 'Események',
            contacts: 'Kapcsolat',
            organisations: 'Egyesületek',
            persons: 'Személyek',
            abilities: 'Képességek',
            exercises: 'Gyakorlatok',
            groups: 'Csoportok',
            traininghead: 'Felkészülések',
            allresults: 'Összes Eredmény',
            paymentforms: 'Fizetési űrlapok',
            permissions: 'Jogosultságok'
        },
        auth: {
            login: 'Bejelentkezés',
            logout: 'Kijelentkezés',
            email: 'Email cím',
            password: 'Jelszó',
            cancel: 'Mégsem',
            submit: 'Tovább',
            changePassword: 'Jelszó módosítása',
            currentPassword: 'Jelenlegi jelszó',
            newPassword: 'Új jelszó',
            newPasswordConfirm: 'Új jelszó megerősítése',
            passwordChanged: 'Jelszó sikeresen módosítva!',
            passwordMismatch: 'A két új jelszó nem egyezik!',
        },
        buttons: {
            new: 'Új adat',
            delete: 'Törlés',
            save: 'Mentés',
            cancel: 'Mégsem',
            edit: 'Szerkesztés',
        },
        messages: {
            loading: 'Betöltés...',
            saving: 'Mentés folyamatban...',
            error: 'Hiba történt',
            success: 'Sikeres művelet',
            confirmDelete: 'Biztosan törölni szeretné?',
            invalidData: 'Érvénytelen adatok!',
        },
        grid: {
            persons: 'Sportolók, Személyek',
            name: 'Név',
            birthDate: 'Születési dátum',
            email: 'Email cím',
            gender: 'Nem',
            organisation: 'Szervezet',
            grade: 'Övfokozat',
        }
    },
    en: {
        nav: {
            home: 'Home',
            events: 'Events',
            contacts: 'Contacts',
            organisations: 'Organisations',
            persons: 'Persons',
            abilities: 'Abilities',
            exercises: 'Exercises',
            groups: 'Groups',
            traininghead: 'Training',
            allresults: 'All Results',
            paymentforms: 'Payment Forms',
        },
        auth: {
            login: 'Login',
            logout: 'Logout',
            email: 'Email address',
            password: 'Password',
            cancel: 'Cancel',
            submit: 'Submit',
            changePassword: 'Change password',
            currentPassword: 'Current password',
            newPassword: 'New password',
            newPasswordConfirm: 'Confirm new password',
            passwordChanged: 'Password changed successfully!',
            passwordMismatch: 'The two new passwords do not match!',
        },
        buttons: {
            new: 'New',
            delete: 'Delete',
            save: 'Save',
            cancel: 'Cancel',
            edit: 'Edit',
        },
        messages: {
            loading: 'Loading...',
            saving: 'Saving...',
            error: 'An error occurred',
            success: 'Operation successful',
            confirmDelete: 'Are you sure you want to delete?',
            invalidData: 'Invalid data!',
        },
        grid: {
            persons: 'Athletes, Persons',
            name: 'Name',
            birthDate: 'Birth Date',
            email: 'Email address',
            gender: 'Gender',
            organisation: 'Organisation',
            grade: 'Grade',
        }
    }
};

export const useTranslation = (language = 'hu') => {
    const t = (key) => {
        const keys = key.split('.');
        let value = translations[language];

        for (const k of keys) {
            value = value?.[k];
            if (!value) return key;
        }

        return value || key;
    };

    return { t };
};
